import React, { useState, useEffect } from 'react';
import HeatmapDiagRasterProgressBar from './HeatmapDiagRasterProgressBar';
import Modal from 'components/shared/Modal/Modal';
import AcquisitionRasterCancelWarning from '../AcquisitionRasterCancelWarning/AcquisitionRasterCancelWarning';
import './HeatmapDiagRasterProgressScreen.css';

const HeatmapDiagRasterProgressScreen = (props) => {
  const [showCancelWarning, setShowCancelWarning] = useState(false);
  const isRasterCompleted = props.verticalProgress === 100 && props.horizontalProgress === 100;

  const handleCancelClick = () => {
    const isRasterInProgress =
      (props.verticalProgress > 0 && props.verticalProgress < 100) ||
      (props.horizontalProgress > 0 && props.horizontalProgress < 100);

    if (isRasterInProgress) {
      setShowCancelWarning(true);
    } else {
      props.onClose();
    }
  };

  // Pass this function to parent through props
  useEffect(() => {
    if (props.onSetCloseHandler) {
      props.onSetCloseHandler(handleCancelClick);
    }
  }, [props.verticalProgress, props.horizontalProgress]);

  return (
    <>
      <div
        id="HeatmapDiagRasterProgressScreen_Outer_Container"
        className="HeatmapDiagRasterProgressScreen_Outer_Container"
      >
        {(props.selectedPolarization === 'vertical' || props.selectedPolarization === 'both') && (
          <>
            <HeatmapDiagRasterProgressBar
              donorDevice={props.donorDevice}
              progress={props.verticalProgress}
              data-tip={props.selectedPolarization === 'both' ? 'Vertical' : 'In progress'}
            />

            {props.verticalProgress > 0 && props.horizontalProgress === 0 && props.customStatusMessage && (
              <div
                className="HeatmapDiagRasterProgressScreen_StatusMessage"
                style={props.selectedPolarization === 'vertical' ? { bottom: '22%' } : { bottom: '10%' }}
              >
                {props.customStatusMessage}
              </div>
            )}
          </>
        )}

        {(props.selectedPolarization === 'horizontal' || props.selectedPolarization === 'both') && (
          <>
            <HeatmapDiagRasterProgressBar
              donorDevice={props.donorDevice}
              progress={props.horizontalProgress}
              data-tip={props.selectedPolarization === 'both' ? 'Horizontal' : 'In progress'}
            />
            {props.verticalProgress === 100 && props.horizontalProgress > 0 && props.customStatusMessage && (
              <div
                className="HeatmapDiagRasterProgressScreen_StatusMessage"
                style={props.selectedPolarization === 'vertical' ? { bottom: '22%' } : { bottom: '10%' }}
              >
                {props.customStatusMessage}
              </div>
            )}
          </>
        )}

        <div
          id="HeatmapDiagRasterProgressScreen_BottomContainer"
          className={'HeatmapDiagRasterProgressScreen_BottomContainer'}
        >
          <button
            id="HeatmapDiagRasterProgressScreen_CancelButton"
            className="HeatmapDiagRasterProgressScreen_CancelButton"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
          {/* <button
            type="submit"
            id='HeatmapDiagRasterProgressScreen_NextButton'
            className={classnames({
              HeatmapDiagRasterProgressScreen_NextButton: true,
              HeatmapDiagRasterProgressScreen_NextButton_Disabled:
                getRasterInfoStatus === Status.PENDING ||
                getRasterInfoStatus === Status.FAILURE ||
                (props.commissioningProgress !== 100 && props.customStatus !== 'awaiting_activeBeam')
            })}
            onClick={() => {
              props.onNext(2, null);
            }}
          >
            {getRasterInfoStatus === Status.PENDING ? BUTTON_LOADING_CIRCLE : 'Next'}
          </button> */}
        </div>
      </div>

      {showCancelWarning && (
        <Modal close={() => setShowCancelWarning(false)} height={238} width={454}>
          <AcquisitionRasterCancelWarning
            title="Raster"
            rasterStatus={isRasterCompleted ? 'completed' : 'in_progress'}
            onCancel={() => setShowCancelWarning(false)}
            onProceed={() => {
              setShowCancelWarning(false);
              props.onClose();
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default React.memo(HeatmapDiagRasterProgressScreen);
